import { isValid, format } from 'date-fns';

export const renderDate = (date, prefix, includeTime, fallback = '-') => {
  if (!isValid(date)) {
    return fallback;
  }

  return `${prefix ? prefix : ''}${format(date, 'yyyy-MM-dd')}`;
};


// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/cornerstone-widget-block/utils/text-display.js